import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AgentResponse } from '@order/models/gen-ai-playground-model';
import { ImageOrderingTracingService } from '@order/pages/image-ordering/tracking/tracing/image-ordering-tracing.service';
import { PanAppState } from '@panamax/app-state';
import { ImageOrderingApiResponse } from '@shared/models/ai-agent-response';
import { OrderItemService } from '@shared/services/order-item.service';
import { ProductService } from '@shared/services/product/product.service';
import { ServiceHandlerService } from '@shared/services/service-handler.service';
import { catchError, first, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrderAiAgentService {
  constructor(
    private http: HttpClient,
    private orderItemService: OrderItemService,
    private productService: ProductService,
    private serviceHandlerService: ServiceHandlerService,
    private imageOrderingTracingService: ImageOrderingTracingService,
  ) {}

  searchByImage(
    body: any,
    orderItemStateEntities: any,
  ): Observable<ImageOrderingApiResponse | { error: boolean }> {
    this.imageOrderingTracingService.trackImageOrderingUpload();
    return this.serviceHandlerService
      .post<AgentResponse>(environment.orderImageApiUrl, body)
      .pipe(
        first(),
        map((data: any) => {
          const matches: any = data?.matches || [];
          if (matches.length > 0) {
            matches.forEach((prod: any) => {
              if (prod.matchedProductNumber) {
                const pNum: number = parseInt(prod.matchedProductNumber);
                this.productService.loadProduct(pNum);
                this.productService.getProduct(pNum);
                const cs =
                  orderItemStateEntities[pNum]?.unitsOrdered?.currentValue;
                const ea =
                  orderItemStateEntities[pNum]?.eachesOrdered?.currentValue;
                this.orderItemService.changeMultiQuantity(
                  pNum,
                  (cs || 0) + (prod.quantityCases || 0),
                  (ea || 0) + (prod.quantityEaches || 0),
                  null,
                  true,
                  false,
                  true,
                );
              }
            });
          }
          this.imageOrderingTracingService.trackImageOrderingUploadSuccess();
          return data;
        }),
        catchError(err => {
          this.imageOrderingTracingService.trackImageOrderingUploadFail(err);
          return of({ error: true });
        }),
      );
  }
}
